export default __webpack_public_path__ + "static/media/Laboratory_HTB.bdb7d47e.md";